export const normalizeName = (name, isFile = false) => {
    if (!name) return isFile ? "Untitled" : "Untitled";

    // First, replace all spaces in the entire name with underscores
    const sanitizedName = name;

    let baseName = sanitizedName;
    let extension = "";

    if (isFile) {
        const lastDotIndex = sanitizedName.lastIndexOf(".");
        if (lastDotIndex !== -1 && lastDotIndex !== 0) {
            baseName = sanitizedName.substring(0, lastDotIndex);
            extension = sanitizedName.substring(lastDotIndex);
        }
    }

    let normalizedBase = baseName;

    if (isFile) {
        // Allow alphanumeric, underscore, dot, and hyphen for files
        // Use a safe regex pattern [a-zA-Z0-9._-] to avoid invalid range issues
        normalizedBase = normalizedBase.replace(/[^a-zA-Z0-9._-]/g, "");
        // Also sanitize extension just in case
        if (extension) {
            extension = extension.replace(/[^a-zA-Z0-9._-]/g, "");
        }
    } else {
        // Folders: replace dots with underscores, allow only alphanumeric, underscore, and hyphen
        normalizedBase = normalizedBase.replace(/\./g, "_").replace(/[^a-zA-Z0-9_-]/g, "");
    }

    const maxLength = 255;
    const availableLength = Math.max(0, maxLength - extension.length);

    // Truncate base name if it exceeds available length
    if (normalizedBase.length > availableLength) {
        normalizedBase = normalizedBase.substring(0, availableLength);
    }

    // Truncate extension if it's longer than maxLength itself (edge case)
    if (availableLength === 0 && extension.length > maxLength) {
        extension = extension.substring(0, maxLength);
    }

    // Final Cleanup: Remove leading/trailing underscores and collapse multiple underscores
    // IMPORTANT: This must happen AFTER truncation to ensure no trailing underscores remain
    normalizedBase = normalizedBase.replace(/^_+|_+$/g, "").replace(/_+/g, "_");

    if (normalizedBase.length === 0) {
        normalizedBase = "Untitled";
    }

    return normalizedBase + extension;
};
